/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';

const NameKPI = ({
    activityName,
    activityGoalAndKPI,
}: Partial<{ activityName: string; activityGoalAndKPI: string }>) => (
    <>
        <Row>
            <ValueCell label="Activity Name" value={activityName} />
        </Row>
        <Row>
            <ValueCell label="Activity Goals & KPIs" value={activityGoalAndKPI} />
        </Row>
    </>
);

export default NameKPI;
